// extracted by mini-css-extract-plugin
module.exports = {"root":"Error404_root__0bG11","linksContainer":"Error404_linksContainer__qVV0X","links":"Error404_links__nVQgP"};